import { render, staticRenderFns } from "./ProductsTabCard.vue?vue&type=template&id=6bc0f807&scoped=true&"
import script from "./ProductsTabCard.vue?vue&type=script&lang=js&"
export * from "./ProductsTabCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTabCard.vue?vue&type=style&index=0&id=6bc0f807&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0f807",
  null
  
)

export default component.exports